<template>
  <div>
    <div class="pb-4 columns">
      <span
        class="pr-5 column is-left force-left"
        v-if="showSendTestEmail !== undefined && showSendTestEmail === true"
        ><b-button
          type="is-primary"
          @click.prevent="processSendTestEmail(content, subject)"
          :disabled="isReadOnly === true"
          >Send Test Email</b-button
        ></span
      >
      <span v-if="!isOnChanged" class="pr-5 column is-right" style="text-align: right !important;"
        ><b-button
          type="is-primary"
          @click="finalizeMessage(content, subject, isDuplex, isColor)"
          :disabled="isReadOnly === true"
          >Save</b-button
        ></span
      >
    </div>
    <div
      class="media-content columns"
      v-if="showMailOptions === true"
      style="overflow: hidden !important;"
    >
      <div class="column is-1 force-left">
        <b-checkbox
          v-model="isDuplex"
          :native-value="isDuplex"
          :disabled="isReadOnly === true"
        ></b-checkbox>
      </div>
      <div class="column is-2 force-left">
        Full Duplex
      </div>
      <div class="column is-1 force-left">
        <b-checkbox
          v-model="isColor"
          :native-value="isColor"
          :disabled="isReadOnly === true"
        ></b-checkbox>
      </div>
      <div class="column is-2 force-left">
        Color
      </div>
    </div>
    <div class="pb-3" v-if="showSendTestEmail !== undefined && showSendTestEmail === true">
      <div class="columns">
        <span class="column is-3 text-right"
          >Subject Line<br /><span class="small-text is-right">Max 100 characters</span></span
        ><span class="column is-9">
          <b-field
            label=""
            :message="!subject && startEmailValidation ? 'The Email subject is required' : ''"
            :type="!subject && startEmailValidation ? 'is-danger' : 'none'"
            ><input
              style="width:500px !important; border-width: 1px; border-color: #63666A;"
              name="EmailSubject"
              class="text pl-2"
              type="text"
              vid="EmailSubject"
              id="EmailSubject"
              placeholder="Email Subject"
              spellcheck="true"
              aria-label="Email Subject"
              rules="max:100"
              maxlength="100"
              v-model="subject"
              @blur="finalizeMessage(content, subject, isDuplex, isColor)"
              :disabled="isReadOnly === true"
          /></b-field>
        </span>
      </div>
    </div>
    <vue-editor
      id="editor"
      v-if="!showSms"
      v-model="content"
      maxlength="8000"
      useCustomImageHandler
      :style="
        `${this.isReadOnly === true ? 'background-color: #f1f1f1' : 'background-color: white'}`
      "
      @image-added="handleImageAdded"
      @image-removed="handleImageRemoved"
      @blur="finalizeMessage(content, subject, isDuplex, isColor)"
      :editor-toolbar="customToolbar"
      :disabled="isReadOnly === true"
    />
    <div v-if="showSms !== undefined && showSms && showSms === true">
      <div class="columns pb-3">
        <span class="column is-2 text-right"
          >Subject Line<br /><span class="small-text is-right">Max 25 characters</span></span
        ><span class="column is-10">
          <b-field
            label=""
            :message="!subject && startSmsValidation ? 'The SMS subject is required' : ''"
            :type="!subject && startSmsValidation ? 'is-danger' : 'none'"
            ><input
              style="width:500px !important;padding-left:10px;"
              name="SmsSubject"
              class="text"
              type="text"
              vid="SmsSubject"
              id="SmsSubject"
              placeholder="SMS Subject"
              spellcheck="true"
              aria-label="SMS Subject"
              rules="max:25"
              maxlength="25"
              v-model="subject"
              @blur="finalizeMessage(content, subject, isDuplex, isColor)"
              :disabled="isReadOnly === true"/></b-field
        ></span>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-field
            label=""
            :message="!content && startSmsValidation ? 'The SMS message is required' : ''"
            :type="!content && startSmsValidation ? 'is-danger' : 'none'"
          >
            <textarea
              style="width:1100px !important;"
              class="textarea"
              ref="textarea"
              placeholder=" SMS Message"
              :maxlength="100"
              v-model="content"
              @blur="finalizeMessage(content, subject, isDuplex, isColor)"
              :disabled="isReadOnly === true"
            />
          </b-field>
        </div>
      </div>
    </div>
    <div>
      {{ message }}
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js'

export default {
  name: 'MessageComposer',
  props: {
    message: String,
    composedText: String,
    composedSubject: String,
    composedIsFullDuplex: Boolean,
    composedIsColor: Boolean,
    showMailOptions: Boolean,
    showPreview: Boolean,
    showSendTestEmail: Boolean,
    showSms: Boolean,
    showAttachments: Boolean,
    finalizeMessage: Function,
    saveMessageForFinalize: Function,
    processSendTestEmail: Function,
    processPreview: Function,
    processAttachments: Function,
    handleImageAdded: Function,
    handleImageRemoved: Function,
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isOnChanged: Boolean
  },
  components: {
    VueEditor
  },
  data() {
    return {
      content: '',
      subject: '',
      isDuplex: false,
      isColor: false,
      startSmsValidation: false,
      startEmailValidation: false,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link'],
        ['clean'],
        ['image']
      ]
    }
  },
  methods: {},
  watch: {
    async content() {
      console.debug('this.isOnChanged...' + this.isOnChanged + ', ' + this.content)

      if (this.showSms && this.showSms === true && this.isReadOnly === false) {
        this.startSmsValidation = true
      }

      if (this.showSendTestEmail && this.showSendTestEmail === true) {
        this.startEmailValidation = true
      }

      if (this.content && this.subject && this.isReadOnly === false) {
        if (this.showSms && this.showSms === true) {
          this.$store.dispatch('communication/composedSmsMessage', {
            smsMessage: this.content
          })
        } else if (this.showSendTestEmail && this.showSendTestEmail === true) {
          this.$store.dispatch('communication/composedEmailMessage', {
            emailMessage: this.content
          })
        }
        this.processPreview(this.content, this.subject)
      }

      if (this.isOnChanged === true && this.content && this.isReadOnly === false) {
        console.debug('watch content change finalize message...')
        this.saveMessageForFinalize(this.content, this.subject, this.isDuplex, this.isColor)
      }
    },
    async subject() {
      if (this.content && this.subject && this.isReadOnly === false) {
        if (this.showSms && this.showSms === true) {
          this.$store.dispatch('communication/saveSmsSubject', {
            smsSubject: this.subject
          })
        } else if (this.showSendTestEmail && this.showSendTestEmail === true) {
          this.$store.dispatch('communication/saveEmailSubject', {
            emailSubject: this.subject
          })
        }

        this.processPreview(this.content, this.subject)
      }

      if (this.isOnChanged === true && this.content && this.subject && this.isReadOnly === false) {
        this.saveMessageForFinalize(this.content, this.subject, this.isDuplex, this.isColor)
      }
    },

    async isColor() {
      if (this.isOnChanged === true && this.content && this.isReadOnly === false) {
        console.debug('watch isColor change finalize message...')
        this.saveMessageForFinalize(this.content, this.subject, this.isDuplex, this.isColor)
      }
    },

    async isDuplex() {
      if (this.isOnChanged === true && this.content && this.isReadOnly === false) {
        console.debug('watch isDuplex change finalize message...')
        this.saveMessageForFinalize(this.content, this.subject, this.isDuplex, this.isColor)
      }
    }
  },

  mounted() {
    this.content = this.composedText
    this.subject = this.composedSubject
    this.isColor = this.composedIsColor
    this.isDuplex = this.composedIsFullDuplex
  }
}
</script>
<style lang="css">
@import '~vue2-editor/dist/vue2-editor.css';

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>
